import { clsx } from 'modules/Utils';
import Icon from 'elements/Icon';
import { CSSProperties } from 'react';
import Colors from 'modules/Colors';

const PLATFORM_LOGO_MAPPING: Record<string, { title: string, icon: string }> = {
    "spotify": {
        "title": "Spotify",
        "icon": 'spotify',
    },
    "deezer": {
        "title": "Deezer",
        "icon": 'deezer',
    },
    "apple_music": {
        "title": "Apple Music",
        "icon": 'appleMusic',
    },
    "audiomack": {
        "title": "Audiomack",
        "icon": 'audiomack',
    },
    "soundcloud": {
        "title": "SoundCloud",
        "icon": 'soundcloud',
    },
    "manually": {
        "icon": 'none',
        "title": "Added manually"
    },
    "none": {
        "icon": 'none',
        "title": "-"
    }
}

interface PlatformCellProps {
    className: string,
    platformKey?: string,
    flexDirection?: string,
    justifyContent?: string,
}

const PlatformCell = ({
    className,
    platformKey = "none",
}: PlatformCellProps) => {
    const { icon, title } = PLATFORM_LOGO_MAPPING[platformKey] ?? PLATFORM_LOGO_MAPPING["none"]

    return (
        <div
            className={clsx("platformCellComponent", className)}
            style={sty.platformCellComponent}
        >
            <Icon
                className="platformIconTeamTable"
                icon={icon}
                size={24}
            />
            <div className="platformTitleTeamTable">{title}</div>
        </div>
    )
}

const sty: Record<string, CSSProperties> = {
    platformCellComponent: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        color: Colors.greyDark,
        gap: 4,
    }
}
export default PlatformCell;